import React from 'react';

const Contacts = () => {
    return (
        <div className="contacts">
            <div className="contacts-items">
                <div className="contacts-item">
                    <div className="contacts-item-description">
                        <p>
                            <a href="mailto:vladucu.voican@gmail.com">vladucu.voican@gmail.com</a>
                        </p>
                    </div>

                    <div className="contacts-item-title">
                        <h6>Email</h6>
                    </div>
                </div>

                <div className="contacts-item">
                    <div className="contacts-item-description">
                        <p>Strada Calea Unirii Nr 101 etaj 1, Craiova, Dolj</p>
                    </div>

                    <div className="contacts-item-title">
                        <h6>Adresa</h6>
                    </div>
                </div>

                {/* <div className="contacts-item">
                    <div className="contacts-item-description">
                        <p>
                            <a href="tel:005053255350539">0050 (5325) 535-0539</a>
                        </p>
                    </div>

                    <div className="contacts-item-title">
                        <h6>Phone</h6>
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default Contacts;
